import {Component, OnDestroy, OnInit} from '@angular/core';
import {ProjectConstants} from '../../../project-constants';
import {FormBuilder, FormGroup, NgForm, Validators} from '@angular/forms';
import {Subscription} from 'rxjs';
import {ActivatedRoute, Router} from '@angular/router';
import {Sl2AnagrafService} from '../../../general-services/service-sl2-anagraf/sl2-anagraf.service';
import {LayerModel} from '../../../../models/LayerModel';
import * as toastr from 'toastr';

@Component({
  selector: 'app-new-layer-anagraf',
  templateUrl: './new-sl2-anagraf.component.html',
  styleUrls: ['./new-sl2-anagraf.component.scss']
})
export class NewSl2AnagrafComponent extends ProjectConstants implements OnInit, OnDestroy {

  layer: LayerModel;
  formValidator: FormGroup;
  formBuilder: FormBuilder;
  saveSubscribe: Subscription;

  constructor(private route: ActivatedRoute, private router: Router,
              private sl2AnagrafService: Sl2AnagrafService) {
    super();

    this.layer = new LayerModel();

    this.formBuilder = new FormBuilder();

    this.formValidator = this.formBuilder.group({
      cod: [this.layer.cod, [Validators.required]],
      description: [this.layer.description, [Validators.required]]
    });
  }

  ngOnInit() {

  }

  cancel(event: any) {
    event.preventDefault();
    this.router.navigate([this.LINKS.MASTER_DATA + this.LINKS.ANAGRAPH.SL2_ANAGRF]);
  }

  save(event: any, form: NgForm, clickSalva ?: boolean) {
    if (event.key === 'Enter' || clickSalva) {
      event.preventDefault();
      this.layer.cod = this.formValidator.value.cod;
      this.layer.description = this.formValidator.value.description;
      this.saveSubscribe = this.sl2AnagrafService.save(this.sl2AnagrafService.baseUrl, this.layer).subscribe(
        (result: any) => {
          if (result === -1) {
            toastr.options.timeout = 5000;
            toastr.warning('Duplicate item, Layer Cod already exists', 'Warning');
          } else {
            toastr.success('Element added with success', 'Success');
            this.router.navigate([this.LINKS.MASTER_DATA + this.LINKS.ANAGRAPH.SL2_ANAGRF]);
          }
        }, error => {
          toastr.error('Element has not edited', 'Error');
        });
    }
  }

  ngOnDestroy(): void {
    if (this.saveSubscribe) {
      this.saveSubscribe.unsubscribe();
    }
  }

}
